import { useBrandingConfig } from "@needl-ai/common/branding/config";
import { useIsICRAResearchAssistBranding } from "@needl-ai/common/branding/hooks";

type AIDisclaimerVariant = "branded" | "generic";

interface AIDisclaimerProps {
  variant?: AIDisclaimerVariant;
  className?: string;
}

const AIDisclaimer = ({
  variant = "generic",
  className = "text-xs text-center text-muted-foreground mt-2",
}: AIDisclaimerProps) => {
  const brandingConfig = useBrandingConfig();
  const isICRAResearchAssist = useIsICRAResearchAssistBranding();

  if (variant === "branded" && isICRAResearchAssist) {
    return null;
  }

  const text =
    variant === "branded"
      ? `${brandingConfig.disclaimerAppName} is an AI and can make mistakes. Please double-check responses`
      : "AI can make mistakes. Always verify critical information before acting on it.";

  return <p className={className}>{text}</p>;
};

export { AIDisclaimer };
